var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-wrap"},[_c('div',{staticClass:"login-content"},[_c('div',{staticClass:"login-box"},[_c('div',{staticClass:"login-body"},[_c('Qrcode',{on:{"handleLogin":_vm.handleLogin}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }